// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-content {
  background: #fff;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  flex-direction: column;
  flex: 1 1 0;
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/NavTabs/TabContent.css","webpack://./services/frontend/app/components/NavTabs/TabContent.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf","sourcesContent":[".tab-content {\n  background: #fff;\n  border-bottom-left-radius: 3px;\n  border-bottom-right-radius: 3px;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0;\n}\n",".tab-content {\n  background: #fff;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n  flex-direction: column;\n  flex: 1 1 0;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
